import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  cognitoUser: any;
  errorState?: { message: string };
  isLoading = false;

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.errorState = this.authService.errorState!;

    if (this.authService.loginState) {
      this.navigateToHome();
    }
  }

  navigateToHome() {
    this.isLoading = true;
    return this.authService
      .validateLogin()
      .then(() => {
        this.router.navigate(['./']);
      })
      .finally(() => (this.isLoading = false));
  }

  federatedSignIn() {
    this.authService.federatedOktaSignIn();
  }
}
